module.exports = __webpack_public_path__ + "static/img/divide_img.24272e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/divide_img.png
// module id = uCfp
// module chunks = 1